import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62 62"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g transform="translate(12 15)">
        <path d="M34.9 26.6h3v-10l-6.3-8.7h-7.5M13 26.6h14.1m-3-5v-20H1.6v25h3.6" />
        <circle cx="9.1" cy="26.6" r="3.8" />
        <circle cx="31" cy="26.6" r="3.8" />
        <path d="M34.1 11.6h-5.9v5h9.6" />
        <path stroke="none" fill="currentColor" d="M9.1 25.4c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2 1.2-.6 1.2-1.2-.5-1.2-1.2-1.2zm21.9 0c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2 1.2-.6 1.2-1.2-.5-1.2-1.2-1.2z" />
      </g>
    </svg>
  </span>
);

export default icon;
